import { render, staticRenderFns } from "./ProjectTitle.vue?vue&type=template&id=43083bd6&scoped=true"
import script from "./ProjectTitle.vue?vue&type=script&lang=ts"
export * from "./ProjectTitle.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTitle.vue?vue&type=style&index=0&id=43083bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43083bd6",
  null
  
)

export default component.exports